import request from '@/utils/request'
import request1 from '@/utils/request1'
import { getToken } from '../utils/auth'
export function getLoad () {
  return request({
    url: '/loading',
    method: 'get',
    params: { token: getToken() }
  })
}
// 查找疾病类别及名称
export function querydiseasename () {
  return request({
    url: '/querydiseasename',
    method: 'post',
    params: { token: getToken() }
  })
}
// 分类设备统计数量，没有返回的设备类型，数量是0
export function querydataviewdevicecount () {
  return request({
    url: '/querydataviewdevicecount',
    method: 'post',
    params: { token: getToken() }
  })
}
// /人员信息统计
export function querydataviewpersoncount () {
  return request({
    url: '/querydataviewpersoncount',
    method: 'post',
    params: { token: getToken() }
  })
}
// 大屏服务统计
export function querydataviewservicecount () {
  return request1({
    url: '/querydataviewservicecount',
    method: 'post',
    params: { token: getToken() }
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js